module.exports = __webpack_public_path__ + "img/xkool_logo_white.8fd658fa.svg";